import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-errore',
  templateUrl: './errore.component.html',
  styleUrls: ['./errore.component.scss']
})
export class ErroreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
